/* tslint:disable */

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DefaultHttpOptions, HttpOptions } from './';
import { USE_DOMAIN, USE_HTTP_OPTIONS, APIClient } from './api-client.service';

import * as models from './models';
import * as guards from './guards';

/**
 * Created with https://github.com/flowup/api-client-generator
 */
@Injectable()
export class GuardedAPIClient extends APIClient {

  constructor(readonly httpClient: HttpClient,
              @Optional() @Inject(USE_DOMAIN) domain?: string,
              @Optional() @Inject(USE_HTTP_OPTIONS) options?: DefaultHttpOptions) {
    super(httpClient, domain, options);
  }

  getSystemSettings(
    requestHttpOptions?: HttpOptions
  ): Observable<models.SystemSettingsDto> {
    return super.getSystemSettings(requestHttpOptions)
      .pipe(tap((res: any) => guards.isSystemSettingsDto(res) || console.error(`TypeGuard for response 'SystemSettingsDto' caught inconsistency.`, res)));
  }

  getContracts(
    requestHttpOptions?: HttpOptions
  ): Observable<models.ContractDto[]> {
    return super.getContracts(requestHttpOptions)
      .pipe(tap((res: any) => guards.isContractDto(res) || console.error(`TypeGuard for response 'ContractDto' caught inconsistency.`, res)));
  }

  getContractById(
    args: {
      iD: number,  // Szerződés azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.ContractDto> {
    return super.getContractById(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isContractDto(res) || console.error(`TypeGuard for response 'ContractDto' caught inconsistency.`, res)));
  }

  getContractsSearchList(
    args: {
      koopFrameContractID?: string,  // (optional) Keretszerződés szám (kötvényszám)
      productTypeSID?: string,  // (optional) Szerződés típus azonosítója
      stateSID?: string,  // (optional) Szerződés állapot azonosítója
      contractorName?: string,  // (optional) Szerződő neve
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.ContractSearchListItemDto[]> {
    return super.getContractsSearchList(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isContractSearchListItemDto(res) || console.error(`TypeGuard for response 'ContractSearchListItemDto' caught inconsistency.`, res)));
  }

  postContractsInsurantsUpload(
    args: {
      insurantsData: models.ContractsInsurantsUploadDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.UFOFileInfoResultDto> {
    return super.postContractsInsurantsUpload(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isUFOFileInfoResultDto(res) || console.error(`TypeGuard for response 'UFOFileInfoResultDto' caught inconsistency.`, res)));
  }

  getContractsAgent(
    args: {
      contractId: number,  // Szerződés belső azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.AgentDto> {
    return super.getContractsAgent(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isAgentDto(res) || console.error(`TypeGuard for response 'AgentDto' caught inconsistency.`, res)));
  }

  getManpowerReportBySubContractId(
    args: {
      subContractId: number,  // Alszerződés azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.ManpowerReportDto[]> {
    return super.getManpowerReportBySubContractId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isManpowerReportDto(res) || console.error(`TypeGuard for response 'ManpowerReportDto' caught inconsistency.`, res)));
  }

  getManpowerReportByKoopSubContractId(
    args: {
      koopSubContractId: number,  // Alszerződés KOOP azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.ManpowerReportDto[]> {
    return super.getManpowerReportByKoopSubContractId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isManpowerReportDto(res) || console.error(`TypeGuard for response 'ManpowerReportDto' caught inconsistency.`, res)));
  }

  getConnectedContracts(
    args: {
      iD: number,  // Aktív keretszerződés azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.ContractToContractDto[]> {
    return super.getConnectedContracts(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isContractToContractDto(res) || console.error(`TypeGuard for response 'ContractToContractDto' caught inconsistency.`, res)));
  }

  saveConnectedContracts(
    args: {
      iD: number,  // Aktív keretszerződés azonosítója
      connectedContracts: any,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.ContractToContractDto[]> {
    return super.saveConnectedContracts(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isContractToContractDto(res) || console.error(`TypeGuard for response 'ContractToContractDto' caught inconsistency.`, res)));
  }

  getContractAdministrationDataByConnectionKey(
    args: {
      connectionKey: string,  // Passzív keretszerződés koop-os azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.PassiveContractAdministrationDto> {
    return super.getContractAdministrationDataByConnectionKey(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isPassiveContractAdministrationDto(res) || console.error(`TypeGuard for response 'PassiveContractAdministrationDto' caught inconsistency.`, res)));
  }

  getContractAdministrationData(
    args: {
      koopPassiveFrameContractId: string,  // Passzív keretszerződés koop-os azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.PassiveContractAdministrationDto> {
    return super.getContractAdministrationData(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isPassiveContractAdministrationDto(res) || console.error(`TypeGuard for response 'PassiveContractAdministrationDto' caught inconsistency.`, res)));
  }

  saveContractAdministrationData(
    args: {
      koopPassiveFrameContractId: string,  // Passzív keretszerződés koop-os azonosítója
      passiveContractAdministration: models.PassiveContractAdministrationDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.PassiveContractAdministrationDto> {
    return super.saveContractAdministrationData(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isPassiveContractAdministrationDto(res) || console.error(`TypeGuard for response 'PassiveContractAdministrationDto' caught inconsistency.`, res)));
  }

  getPassiveContract(
    args: {
      connectionKey: string,  // Passzív keretszerződés koop-os azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.HIPContractDto> {
    return super.getPassiveContract(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isHIPContractDto(res) || console.error(`TypeGuard for response 'HIPContractDto' caught inconsistency.`, res)));
  }

  checkDuplicateDocumentNumbers(
    args: {
      koopFrameContractId: string,  // Keretszerződés szám (kötvényszám)
      socialSecurityNumber?: string,  // (optional) TAJ szám
      taxNumber?: string,  // (optional) Adószám
      passport?: string,  // (optional) Útlevél szám
    },
    requestHttpOptions?: HttpOptions
  ): Observable<string> {
    return super.checkDuplicateDocumentNumbers(args, requestHttpOptions)
      .pipe(tap((res: any) => typeof res === 'string' || console.error(`TypeGuard for response 'string' caught inconsistency.`, res)));
  }

  payInsuredPersonFromHip(
    args: {
      insuredPersonFromHIPId: number,  // InsuredPersonFromHIP táblában található azonosító
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.StringResponseDto> {
    return super.payInsuredPersonFromHip(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isStringResponseDto(res) || console.error(`TypeGuard for response 'StringResponseDto' caught inconsistency.`, res)));
  }

  processPaymentResponse(
    args: {
      providerData: any,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.StringResponseDto> {
    return super.processPaymentResponse(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isStringResponseDto(res) || console.error(`TypeGuard for response 'StringResponseDto' caught inconsistency.`, res)));
  }

  sendContractFromHipById(
    args: {
      insuredPersonFromHIPId: number,  // InsuredPersonFromHIP táblában található azonosító
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.SmartCubePDFGenerationResponseDto> {
    return super.sendContractFromHipById(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isSmartCubePDFGenerationResponseDto(res) || console.error(`TypeGuard for response 'SmartCubePDFGenerationResponseDto' caught inconsistency.`, res)));
  }

  getAddress(
    args: {
      zip: number,  // Irányítószám
      city?: string,  // (optional) Város
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.CentralZIPDto[]> {
    return super.getAddress(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isCentralZIPDto(res) || console.error(`TypeGuard for response 'CentralZIPDto' caught inconsistency.`, res)));
  }

  getContractProcessingDataByContractId(
    args: {
      iD: number,  // Keretszerződés azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.ContractProcessingDataDto> {
    return super.getContractProcessingDataByContractId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isContractProcessingDataDto(res) || console.error(`TypeGuard for response 'ContractProcessingDataDto' caught inconsistency.`, res)));
  }

  insertExportQueueByContract(
    args: {
      contractId: number,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.StringResponseDto> {
    return super.insertExportQueueByContract(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isStringResponseDto(res) || console.error(`TypeGuard for response 'StringResponseDto' caught inconsistency.`, res)));
  }

  getInsurants(
    args: {
      meta?: models.FilteredSortedPagedDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.PagedNaturalPersonDto> {
    return super.getInsurants(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isPagedNaturalPersonDto(res) || console.error(`TypeGuard for response 'PagedNaturalPersonDto' caught inconsistency.`, res)));
  }

  getInsurantById(
    args: {
      iD: string,  // Biztosított azonosítója (NaturalPersonId || <keret>_<al>_<partner>))
      isPassive?: boolean,  // (optional) A biztosított passzív?
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.NaturalPersonDto> {
    return super.getInsurantById(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isNaturalPersonDto(res) || console.error(`TypeGuard for response 'NaturalPersonDto' caught inconsistency.`, res)));
  }

  patchInsurantById(
    args: {
      iD: number,  // biztosított azonosítója
      insurantsData: models.NaturalPersonDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.NaturalPersonDto> {
    return super.patchInsurantById(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isNaturalPersonDto(res) || console.error(`TypeGuard for response 'NaturalPersonDto' caught inconsistency.`, res)));
  }

  putInsurantById(
    args: {
      iD: number,  // biztosított azonosítója
      validatedNaturalPersonDto: models.ValidatedNaturalPersonDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.NaturalPersonDto> {
    return super.putInsurantById(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isNaturalPersonDto(res) || console.error(`TypeGuard for response 'NaturalPersonDto' caught inconsistency.`, res)));
  }

  createInsurant(
    args: {
      insurantsData: models.NaturalPersonDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.NaturalPersonDto> {
    return super.createInsurant(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isNaturalPersonDto(res) || console.error(`TypeGuard for response 'NaturalPersonDto' caught inconsistency.`, res)));
  }

  forceCreateInsurant(
    args: {
      validatedNaturalPersonDto: models.ValidatedNaturalPersonDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.NaturalPersonDto> {
    return super.forceCreateInsurant(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isNaturalPersonDto(res) || console.error(`TypeGuard for response 'NaturalPersonDto' caught inconsistency.`, res)));
  }

  getInsurantsSearchList(
    args: {
      name?: string,  // (optional) biztosított neve
      meta?: models.FilteredSortedPagedDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.PagedInsurantsSearchListItemDto> {
    return super.getInsurantsSearchList(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isPagedInsurantsSearchListItemDto(res) || console.error(`TypeGuard for response 'PagedInsurantsSearchListItemDto' caught inconsistency.`, res)));
  }

  getInsurantsSearchListByFrameContractId(
    args: {
      frameId: number,  // keretszerződés azonosítója
      name?: string,  // (optional) biztosított neve
      meta?: models.FilteredSortedPagedDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.PagedInsurantsSearchListItemDto> {
    return super.getInsurantsSearchListByFrameContractId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isPagedInsurantsSearchListItemDto(res) || console.error(`TypeGuard for response 'PagedInsurantsSearchListItemDto' caught inconsistency.`, res)));
  }

  getInsurantsSearchListByFrameAndSubContractId(
    args: {
      frameId: number,  // keretszerződés azonosítója
      subId: number,  // alszerződés azonosítója
      name?: string,  // (optional) biztosított neve
      meta?: models.FilteredSortedPagedDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.PagedInsurantsSearchListItemDto> {
    return super.getInsurantsSearchListByFrameAndSubContractId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isPagedInsurantsSearchListItemDto(res) || console.error(`TypeGuard for response 'PagedInsurantsSearchListItemDto' caught inconsistency.`, res)));
  }

  getInsurantsExportByFrameAndSubContractId(
    args: {
      frameId: number,  // keretszerződés azonosítója
      subId: number,  // alszerződés azonosítója
      name?: string,  // (optional) biztosított neve
      meta?: models.FilteredSortedPagedDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.FileDto> {
    return super.getInsurantsExportByFrameAndSubContractId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isFileDto(res) || console.error(`TypeGuard for response 'FileDto' caught inconsistency.`, res)));
  }

  getInsurantsSearchExportByFrameContractId(
    args: {
      frameId: number,  // keretszerződés azonosítója
      name?: string,  // (optional) biztosított neve
      meta?: models.FilteredSortedPagedDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.FileDto> {
    return super.getInsurantsSearchExportByFrameContractId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isFileDto(res) || console.error(`TypeGuard for response 'FileDto' caught inconsistency.`, res)));
  }

  getInsurantsSearchExport(
    args: {
      name?: string,  // (optional) biztosított neve
      meta?: models.FilteredSortedPagedDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.FileDto> {
    return super.getInsurantsSearchExport(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isFileDto(res) || console.error(`TypeGuard for response 'FileDto' caught inconsistency.`, res)));
  }

  getInsurancePeriodsByInsurantId(
    args: {
      insurantId: number,  // Biztosított azonosítója (NaturalPersonId)
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.InsurancePeriodDto[]> {
    return super.getInsurancePeriodsByInsurantId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isInsurancePeriodDto(res) || console.error(`TypeGuard for response 'InsurancePeriodDto' caught inconsistency.`, res)));
  }

  createInsurancePeriodByInsurantId(
    args: {
      insurantId: number,  // Biztosított azonosítója (NaturalPersonId)
      insurancePeriod: models.InsurancePeriodDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.InsurancePeriodDto[]> {
    return super.createInsurancePeriodByInsurantId(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isInsurancePeriodDto(res) || console.error(`TypeGuard for response 'InsurancePeriodDto' caught inconsistency.`, res)));
  }

  saveInsuredPersonFromHip(
    args: {
      insuredPerson: models.HIPInsuredPersonFromHIPDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.HIPInsuredPersonFromHIPDto> {
    return super.saveInsuredPersonFromHip(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isHIPInsuredPersonFromHIPDto(res) || console.error(`TypeGuard for response 'HIPInsuredPersonFromHIPDto' caught inconsistency.`, res)));
  }

  getInsuredPersonFromHipQuery(
    args: {
      insuredPersonFromHIPId?: number,
      offerNumber?: string,
      paymentCode?: string,
      interruptionId?: string,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.HIPInsuredPersonFromHIPDto> {
    return super.getInsuredPersonFromHipQuery(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isHIPInsuredPersonFromHIPDto(res) || console.error(`TypeGuard for response 'HIPInsuredPersonFromHIPDto' caught inconsistency.`, res)));
  }

  checkEmployee(
    args: {
      passiveKoopFrameContractId: string,
      name: string,
      birthDate: string,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.HIPEmployeeDto> {
    return super.checkEmployee(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isHIPEmployeeDto(res) || console.error(`TypeGuard for response 'HIPEmployeeDto' caught inconsistency.`, res)));
  }

  sendProofOfInsurance(
    args: {
      iD: string,  // Biztosított azonosítója (NaturalPersonId || InsuredPersonFromKoop.NaturalPersonUid)
      isPassive: boolean,  // A biztosított passzív?
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.StringResponseDto> {
    return super.sendProofOfInsurance(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isStringResponseDto(res) || console.error(`TypeGuard for response 'StringResponseDto' caught inconsistency.`, res)));
  }

  getProfile(
    requestHttpOptions?: HttpOptions
  ): Observable<models.ProfileDto> {
    return super.getProfile(requestHttpOptions)
      .pipe(tap((res: any) => guards.isProfileDto(res) || console.error(`TypeGuard for response 'ProfileDto' caught inconsistency.`, res)));
  }

  getUsers(
    args: {
      meta?: models.FilteredSortedPagedDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.CirUserDto[]> {
    return super.getUsers(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isCirUserDto(res) || console.error(`TypeGuard for response 'CirUserDto' caught inconsistency.`, res)));
  }

  getUserById(
    args: {
      userId: number,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.UserDetailsDto> {
    return super.getUserById(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isUserDetailsDto(res) || console.error(`TypeGuard for response 'UserDetailsDto' caught inconsistency.`, res)));
  }

  createPBOUser(
    args: {
      userData?: models.CirUserDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.CirUserDto> {
    return super.createPBOUser(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isCirUserDto(res) || console.error(`TypeGuard for response 'CirUserDto' caught inconsistency.`, res)));
  }

  passwordChange(
    requestHttpOptions?: HttpOptions
  ): Observable<models.PasswordChangeDto> {
    return super.passwordChange(requestHttpOptions)
      .pipe(tap((res: any) => guards.isPasswordChangeDto(res) || console.error(`TypeGuard for response 'PasswordChangeDto' caught inconsistency.`, res)));
  }

  retrieveJwt(
    requestHttpOptions?: HttpOptions
  ): Observable<models.JWTDto> {
    return super.retrieveJwt(requestHttpOptions)
      .pipe(tap((res: any) => guards.isJWTDto(res) || console.error(`TypeGuard for response 'JWTDto' caught inconsistency.`, res)));
  }

  getDocument(
    args: {
      boxId: number,
      koopFrameContractId: string,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.HIPFileDto> {
    return super.getDocument(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isHIPFileDto(res) || console.error(`TypeGuard for response 'HIPFileDto' caught inconsistency.`, res)));
  }

  getDocuments(
    args: {
      koopFrameContractId: string,
      contractGroupId: string,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.HIPFileDto> {
    return super.getDocuments(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isHIPFileDto(res) || console.error(`TypeGuard for response 'HIPFileDto' caught inconsistency.`, res)));
  }

  getCaptcha(
    requestHttpOptions?: HttpOptions
  ): Observable<models.GetCaptchaStyledResultDto> {
    return super.getCaptcha(requestHttpOptions)
      .pipe(tap((res: any) => guards.isGetCaptchaStyledResultDto(res) || console.error(`TypeGuard for response 'GetCaptchaStyledResultDto' caught inconsistency.`, res)));
  }

  checkCaptcha(
    args: {
      codeModel?: models.CodeModelDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.CaptchaValidationResponseDto> {
    return super.checkCaptcha(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isCaptchaValidationResponseDto(res) || console.error(`TypeGuard for response 'CaptchaValidationResponseDto' caught inconsistency.`, res)));
  }

  getCoupon(
    args: {
      passiveKoopFrameContractId: string,  // Passzív keretszerződés azonosítója
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.HIPCouponDto[]> {
    return super.getCoupon(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isHIPCouponDto(res) || console.error(`TypeGuard for response 'HIPCouponDto' caught inconsistency.`, res)));
  }

  saveCoupon(
    args: {
      passiveKoopFrameContractId: string,  // Passzív keretszerződés azonosítója
      couponCode: models.HIPCouponDto,
    },
    requestHttpOptions?: HttpOptions
  ): Observable<models.HIPCouponDto> {
    return super.saveCoupon(args, requestHttpOptions)
      .pipe(tap((res: any) => guards.isHIPCouponDto(res) || console.error(`TypeGuard for response 'HIPCouponDto' caught inconsistency.`, res)));
  }

  getKompaktContracts(
    requestHttpOptions?: HttpOptions
  ): Observable<models.KompaktContractDto[]> {
    return super.getKompaktContracts(requestHttpOptions)
      .pipe(tap((res: any) => guards.isKompaktContractDto(res) || console.error(`TypeGuard for response 'KompaktContractDto' caught inconsistency.`, res)));
  }

}
